var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIconImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-icon-img",
    transform: "translate(4739 5301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settings-icon-img-2",
    "data-name": "settings-icon-img",
    d: "M13.945,6.167a.741.741,0,0,0-.711-.616h-.681a.564.564,0,0,1-.487-.358l-.21-.509A.557.557,0,0,1,11.95,4.1l.483-.483a.708.708,0,0,0,.033-.941L11.314,1.524a.689.689,0,0,0-.439-.155.7.7,0,0,0-.49.2L9.9,2.05a.55.55,0,0,1-.6.089L8.8,1.931a.561.561,0,0,1-.348-.483V.766A.741.741,0,0,0,7.832.055a6.3,6.3,0,0,0-1.665,0,.741.741,0,0,0-.616.711v.681a.563.563,0,0,1-.358.487l-.509.21A.573.573,0,0,1,4.1,2.05l-.483-.483a.712.712,0,0,0-.941-.033L1.524,2.686a.706.706,0,0,0,.044.93L2.05,4.1a.56.56,0,0,1,.089.6L1.931,5.2a.56.56,0,0,1-.483.348H.766a.741.741,0,0,0-.711.616A6.4,6.4,0,0,0,0,7a6.468,6.468,0,0,0,.055.833.741.741,0,0,0,.711.616h.681a.564.564,0,0,1,.487.358l.21.509A.556.556,0,0,1,2.05,9.9l-.483.483a.707.707,0,0,0-.033.941l1.152,1.151a.688.688,0,0,0,.439.155.7.7,0,0,0,.49-.2L4.1,11.95a.551.551,0,0,1,.6-.089l.508.208a.56.56,0,0,1,.348.483v.681a.741.741,0,0,0,.616.711,6.327,6.327,0,0,0,1.666,0,.741.741,0,0,0,.616-.711v-.681a.563.563,0,0,1,.358-.487l.509-.21a.574.574,0,0,1,.586.094l.483.483a.712.712,0,0,0,.941.033l1.151-1.152a.705.705,0,0,0-.043-.93L11.95,9.9a.56.56,0,0,1-.089-.6L12.07,8.8a.56.56,0,0,1,.483-.348h.681a.741.741,0,0,0,.711-.616,6.325,6.325,0,0,0,0-1.665ZM7,9.414A2.414,2.414,0,1,1,9.414,7,2.414,2.414,0,0,1,7,9.414",
    transform: "translate(-4737.107 -5299.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 18,
    height: 18,
    transform: "translate(-4739 -5301)",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconImg);
export default __webpack_public_path__ + "static/media/settings-icon-img.0349384a08d39d0f33ea4b4af4138f8f.svg";
export { ForwardRef as ReactComponent };